module.exports = __webpack_public_path__ + "img/2_2-finanziario-torre-0.f3f87dea.png";